import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation CommentResolve($uid: String!){
        comment_resolve (uid: $uid) {
            success
        }
    }
`;

export async function commentResolve(uid: string): Promise<boolean> {
    const result: FetchResult<{ comment_resolve: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: {
            uid: uid,
        },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.comment_resolve.success;
}
